import React from "react";
//import PropTypes from 'prop-types';
import "./savedChatSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
import { URFilesSkeleton } from "./skeletonWidgets/fileSkeleton";
function URSavedChatSkeleton(props: any) {
  return (
    <>
      <div className="savedChatSkeleton">
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size30'/>
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size60'/>
          <URLineSkeleton className='line lineThin size10'/>
        </div>
        <div className="notesIconbtn"><span className="icon_ribbon"></span></div>
        <div className="savedChatBox">
          <div className="notesLine">
            <URLineSkeleton className='line lineThin size95'/>
            <URLineSkeleton className='line lineThin size75'/>
            <URLineSkeleton className='line lineThin size85'/>
            <URLineSkeleton className='line lineThin size90'/>
            <URLineSkeleton className='line lineThin size80'/>
            <URLineSkeleton className='line lineThin size60'/>
          </div>
        </div>

        <div className="btnSec">
          <URLineSkeleton className='line lineThick size60'/>
          <URLineSkeleton className='line lineThin size10'/>
        </div>
        <div className="notesIconbtn"><span className="icon_ribbon"></span></div>
        <div className="savedChatBox">
          <div className="savedChatLine">
            <URLineSkeleton className='line lineThin size95'/>
            <URLineSkeleton className='line lineThin size75'/>
            <URLineSkeleton className='line lineThin size85'/>
            <URLineSkeleton className='line lineThin size60'/>
            <div className="filesDesc">
              <URFilesSkeleton  className='filesPrev sizemd'/>
              <URFilesSkeleton  className='filesPrev sizemd'/>
              <URFilesSkeleton  className='filesPrev sizemd'/>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URSavedChatSkeleton
};